import React from "react";

// Redux
import {useSelector, useDispatch} from "react-redux";
import {createEventSource} from "../../../redux/features/events/sourcesSlice";

// Routing
import {useHistory} from "react-router-dom";

// Components
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Paper from "../../UI/MainPaper";
import EventSourcesForm from "./EventSourcesForm";
import Breadcrumbs from "../../Navigation/Breadcrumbs";

const EventSourcesNew = () => {
  // Redux
  const dispatch = useDispatch();
  const {isLoading} = useSelector(state => state.eventSources);

  // Routing
  const history = useHistory();

  const breadcrumbNameMap = {
    "/events": "Events",
    "/events/sources": "Event Sources",
    "/events/sources/new": "New Event Source",
  };

  const onCancel = () => {
    history.push("/events/sources");
  };
  const onSubmit = async values => {
    const eventSourceObj = {
      events_sources_id: null,
      ...values,
    };

    const res = await dispatch(createEventSource(eventSourceObj));
    // If event was created successfully redirect to events page and show user
    if (!res.error) {
      history.push({
        pathname: "/events/sources",
        state: {
          showSuccess: true,
          snackbarContent: `Your Event Source '${eventSourceObj.src}' was successfully created!`,
          snackbarLink: `/events/sources/${res.id}`,
        },
      });
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Breadcrumbs breadcrumbNameMap={breadcrumbNameMap} />
      </Grid>
      <Grid item xs={12}>
        <Paper>
          <Typography component="h1" variant="h5" gutterBottom>
            New Event Source
          </Typography>
          <EventSourcesForm
            onSubmit={onSubmit}
            onCancel={onCancel}
            isLoading={isLoading}
            submitButtonLabel="Create Event Source"
          />
        </Paper>
      </Grid>
    </Grid>
  );
};

export default EventSourcesNew;
